import { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { DestinationAuthorityMap, Identity } from '../../context/IdentityContext'
import { Destination } from '../../context/AxiosContext'

export default function useTokenInjector() {
    return (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> | InternalAxiosRequestConfig => {
        // Only intercept when the base URL should default to the server. This way we don't send
        // headers to ineligible hosts.
        if (
            (!config.baseURL && !(config.url || '').match(/^http(s)?:\/\//)) ||
            Object.values(Destination).includes(config.baseURL as Destination)
        ) {
            const destination = (config.baseURL as Destination) || Destination.Hammock
            config.baseURL = Identity.current?.getBaseUrl(destination)
            config.headers['Destination'] = destination
        } else if (!config.headers['Destination'] || config.headers['Authorization']) {
            return config
        }

        // Add token to the request.
        const destination = config.headers['Destination'] as Destination
        const authority = DestinationAuthorityMap.get(destination)
        const token = Identity.current?.getToken(authority)

        if (!token?.access_token) {
            return Promise.reject(
                new AxiosError(`Er is geen toegangstoken aanwezig voor '${authority}'.`, 'TOKEN_MISSING', config),
            )
        } else if (token?.token_type !== 'Bearer') {
            return Promise.reject(
                new AxiosError(
                    `De toegangstoken voor '${authority}' is geen bearer token (${token?.token_type}).`,
                    'INVALID_TOKEN_TYPE',
                    config,
                ),
            )
        }

        config.headers['Authorization'] = `${token.token_type} ${token.access_token}`
        config.headers['Destination'] = destination
        return config
    }
}
